import React, { useEffect } from "react";
import { useRootAppStore } from "@hooks";
import { observer } from "mobx-react";
import { ChatBox } from "@features/chat/mobile";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { useFixBody } from "@state/hooks/shared";
import { top, bottom } from "safe-area-insets";
import { isCapacitorPlatform } from "@utils/specific/capacitor";

export default observer(function ChatContainer() {
	const { chatViewStore } = useRootAppStore();

	useEffect(() => {
		return () => chatViewStore.onDispose();
	}, []);

	useFixBody(true, chatViewStore.chatBoxVisible);

	if (!chatViewStore.chatBoxVisible) {
		return null;
	}

	const chatPadding = isCapacitorPlatform()
		? {
				top: top,
				bottom: bottom,
			}
		: {};

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Mobile/ChatContainer.tsx"}
		>
			<div className="chat" style={chatPadding}>
				<ChatBox />
			</div>
		</ErrorBoundaryWithPropagation>
	);
});
